import {
  VISIT_TYPE_LIST_KEY,
  INSTITUTION_KEY,
  VISIT_TIME_LIST_KEY,
  BOOK_RESULT_KEY,
} from '../../types/appointment.types'

export default function () {
  return {
    [VISIT_TYPE_LIST_KEY]: null,
    [INSTITUTION_KEY]: null,
    [VISIT_TIME_LIST_KEY]: [],
    [BOOK_RESULT_KEY]: false,
  }
}
